import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import './Viewer.css';
import Navbar from './Navbar';

const Viewer = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [filters, setFilters] = useState({
    id: '',
    nombre: '',
    departamento: '',
    localidad: '',
    inspector: '',
    estado: '',
    categoria: '',
    avanceMin: 0,
    avanceMax: 100,
  });

  const getEstado = (avance) => {
    if (avance === 100) return 'Finalizado';
    if (avance > 0) return 'En ejecución';
    return 'No iniciado';
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/obras`);
        if (response.ok) {
          const dataFromServer = await response.json();
          setData(dataFromServer);
        } else {
          console.error('Error al cargar las obras');
        }
      } catch (error) {
        console.error('Error de red:', error);
      }
    };
    fetchData();
  }, []);

// ...importaciones
const normalizeText = (text) =>
  text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

const filteredData = data.filter((item) => (
  (filters.id ? item.id === parseInt(filters.id) : true) &&
  (filters.nombre ? normalizeText(item.nombre).includes(normalizeText(filters.nombre)) : true) &&
  (filters.departamento ? normalizeText(item.departamento || '').includes(normalizeText(filters.departamento)) : true) &&
  (filters.localidad ? normalizeText(item.localidad).includes(normalizeText(filters.localidad)) : true) &&
  (filters.inspector ? normalizeText(item.inspector).includes(normalizeText(filters.inspector)) : true) &&
  (filters.estado ? getEstado(item.avance).toLowerCase() === filters.estado.toLowerCase() : true) &&
  (filters.categoria ? normalizeText(item.categoria).includes(normalizeText(filters.categoria)) : true) &&
  (filters.avanceMin ? item.avance >= parseInt(filters.avanceMin) : true) &&
  (filters.avanceMax ? item.avance <= parseInt(filters.avanceMax) : true)
));


  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    navigate('/login');
  };

  return (
    <div className="viewer-page">
      <Navbar userName="Viewer" onLogout={handleLogout} />
      <div className="viewer-container">
        <h2 className="titulo-filtros">Filtros</h2>
        <form className="filtro-mover">
          <input type="number" name="id" value={filters.id} onChange={(e) => setFilters({ ...filters, id: e.target.value })} placeholder="Filtrar por ID" />
          <input type="text" name="departamento" value={filters.departamento} onChange={(e) => setFilters({ ...filters, departamento: e.target.value })} placeholder="Filtrar por Departamento" />
          <input type="text" name="nombre" value={filters.nombre} onChange={(e) => setFilters({ ...filters, nombre: e.target.value })} placeholder="Filtrar por Nombre" />
          <input type="text" name="localidad" value={filters.localidad} onChange={(e) => setFilters({ ...filters, localidad: e.target.value })} placeholder="Filtrar por Localidad" />
          <input type="text" name="inspector" value={filters.inspector} onChange={(e) => setFilters({ ...filters, inspector: e.target.value })} placeholder="Filtrar por Inspector" />
          <select name="estado" value={filters.estado} onChange={(e) => setFilters({ ...filters, estado: e.target.value })}>
            <option value="">Filtrar por Estado</option>
            <option value="Finalizado">Finalizado</option>
            <option value="En ejecución">En ejecución</option>
            <option value="No iniciado">No iniciado</option>
          </select>
          <select name="categoria" value={filters.categoria} onChange={(e) => setFilters({ ...filters, categoria: e.target.value })}>
            <option value="">Filtrar por Categoría</option>
            <option value="Salud">Salud</option>
            <option value="Educacion">Educación</option>
            <option value="Otras Areas">Otras Áreas</option>
          </select>
          <input type="number" name="avanceMin" value={filters.avanceMin} onChange={(e) => setFilters({ ...filters, avanceMin: e.target.value })} placeholder="Avance Mínimo" min="0" max="100" />
          <input type="number" name="avanceMax" value={filters.avanceMax} onChange={(e) => setFilters({ ...filters, avanceMax: e.target.value })} placeholder="Avance Máximo" min="0" max="100" />
        </form>

        <h2 className="titulo-lista">Lista de Obras</h2>

        <div className="table-wrapper">
          <table className="viewer-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Nombre</th>
                <th>Departamento</th>
                <th>Localidad</th>
                <th>Barrio</th>
                <th>Empresa</th>
                <th>Inspector</th>
                <th>Avance (%)</th>
                <th>Estado</th>
                <th>Categoría</th>
                <th>Planos</th>
                <th>Memorias</th>
                <th>Detalles</th>
                <th>Imágenes</th>
                <th>Última Modificación</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.map((item) => (
                <tr key={item.id}>
                  <td>{item.id}</td>
                  <td>{item.nombre}</td>
                  <td>{item.departamento || '-'}</td>
                  <td>{item.localidad}</td>
                  <td>{item.barrio}</td>
                  <td>{item.empresa}</td>
                  <td>{item.inspector}</td>
                  <td>
                    <div className="progress-wrapper">
                      <div className="progress">
                        <div
                          className={`progress-bar ${
                            item.avance > 0 && item.avance < 100
                              ? 'in-progress'
                              : item.avance === 100
                              ? 'completed'
                              : ''
                          }`}
                          style={{ width: `${item.avance}%` }}
                        ></div>
                      </div>
                      <span className="progress-text">{item.avance}%</span>
                    </div>
                  </td>
                  <td>{getEstado(item.avance)}</td>
                  <td>{item.categoria}</td>
                  <td>
                    <a href={item.planos} target="_blank" rel="noopener noreferrer" className="btn-link-detalles">
                      Ver Planos
                    </a>
                  </td>
                  <td>
                    <a href={item.memorias} target="_blank" rel="noopener noreferrer" className="btn-link-imagenes">
                      Ver Memorias
                    </a>
                  </td>
                  <td>
                    <a href={item.detalles} target="_blank" rel="noopener noreferrer" className="btn-link-detalles">
                      Ver Detalles
                    </a>
                  </td>
                  <td>
                    <a href={item.imagenes} target="_blank" rel="noopener noreferrer" className="btn-link-imagenes">
                      Ver Imágenes
                    </a>
                  </td>
                  <td className="last-modified">
                    {format(new Date(item.ultima_modificacion), 'dd/MM/yyyy HH:mm', { locale: es })}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Viewer;
